// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__3t10m","unreadBadge":"styles_unreadBadge__jKHfz","modalContent":"styles_modalContent__2aWny","modal":"styles_modal__2aJqR"};